/**
 *
 * Question
 *
 */

import { mapState, mapMutations, mapActions } from 'vuex';

import { QaQuestionFeedbackMixin } from '@/scripts/QA/Question/mixins/QaQuestionFeedbackMixin';

import { swalWarning } from '@/utils/swal2';

export default {
  name: 'FeedbackEdit',

  mixins: [QaQuestionFeedbackMixin],

  props: {
    p_objQa: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      feedbackContent: '',
    };
  },

  computed: {
    ...mapState('QA/Question', {
      ms_res_feedback: 'res_feedback',
    }),

    c_isFeedbackBlank() {
      return '' === this.feedbackContent;
    },

    c_isFeedbackToolong() {
      return !this.c_isFeedbackBlank && this.feedbackContent.length > 200;
    },

    c_isFeedbackReady() {
      return !this.c_isFeedbackBlank && !this.c_isFeedbackToolong;
    },

    c_isSubmitDisabled() {
      return !this.c_isCanFeedback || !this.c_isFeedbackReady;
    },
  },

  methods: {
    ...mapMutations('QA/Question', {
      mm_UPDATE_QA_ANSWER: 'UPDATE_QA_ANSWER',
    }),

    ...mapActions('QA/Question', {
      ma_feedback: 'feedback',
    }),

    async feedback() {
      await this.ma_feedback({
        qaQuestionId: this.$route.params.id,
        qaAnswerId: this.p_objQa.qaAnswerId,
        assistantId: this.p_objQa.userId,
        feedbackContent: this.feedbackContent,
      });
      if (200 === this.ms_res_feedback.status) {
        this.mm_UPDATE_QA_ANSWER({
          ...this.p_objQa,
          isFeedback: true,
          feedbackContent: this.feedbackContent,
          i_feedbackIsOpen: false,
        });
        this.feedbackContent = '';
      } else {
        swalWarning('问题追问失败');
      }
    },
  },
};
